import { render, staticRenderFns } from "./capacity.vue?vue&type=template&id=6cf0e674&"
import script from "./capacity.vue?vue&type=script&lang=js&"
export * from "./capacity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports